import { render, staticRenderFns } from "./teacher-locked-lexile.vue?vue&type=template&id=1e37e1ae&scoped=true&"
import script from "./teacher-locked-lexile.vue?vue&type=script&lang=js&"
export * from "./teacher-locked-lexile.vue?vue&type=script&lang=js&"
import style0 from "./teacher-locked-lexile.vue?vue&type=style&index=0&id=1e37e1ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e37e1ae",
  null
  
)

export default component.exports